import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { DateTimeFormat } from '@y42/date-time';
import { GitCommit } from '@y42/git';
import { OrgUserQuery } from '@y42/org-user/state';
import { Observable, of, switchMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-git-commit-item[commit]',
  templateUrl: './git-commit-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitCommitItemComponent {
  constructor(private readonly orgUserQuery: OrgUserQuery) {}

  @Input()
  @InputObservable()
  commit?: GitCommit;
  private readonly commit$!: Observable<GitCommit | undefined>;

  protected readonly timeAgoFormat = DateTimeFormat.MediumDate;

  readonly state = connectState(this, {
    user: this.commit$.pipe(
      switchMap((commit) =>
        commit?.authorEmail ? this.orgUserQuery.selectUIEntity(commit.authorEmail) : of(undefined),
      ),
    ),
  });
}
